import { skipToken, useQuery } from '@tanstack/react-query';

import { Boards } from '@air/api';
import { type Workspace } from '@air/api/types';

export const DEFAULT_BOARD_KEY = '@plugin-ui/DEFAULT_BOARD';

export const getDefaultBoardKey = (params: UseDefaultBoardParams) => {
  return [DEFAULT_BOARD_KEY, params];
};

export type UseDefaultBoardParams = {
  workspaceId: Workspace['id'] | undefined;
};

export const useDefaultBoard = (params: UseDefaultBoardParams) => {
  const { workspaceId } = params;

  return useQuery({
    queryFn: workspaceId
      ? () =>
          Boards.getDefaultBoard({
            workspaceId,
          })
      : skipToken,
    queryKey: getDefaultBoardKey(params),
  });
};
